import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class BlueskyProfile extends ApplicationRecord {
  static jsonapiType = "bluesky_profiles";

  @Attr() avatarUrl: string;

  @Attr() bannerUrl: string;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() description: string;

  @Attr() did: string;

  @Attr() displayName: string;

  @Attr() followersCount: number;

  @Attr() followsCount: number;

  @Attr() handle: string;

  @Attr() postsCount: number;

  @Attr() processing: boolean;

  @Attr({ persist: false }) updatedAt: string;
}

export default BlueskyProfile;
